import type { Components } from '@mui/material/styles';

export default function MUISwipeableDrawer(): Components['MuiSwipeableDrawer'] {
  return {};
}
